export enum ForecastNewProductPlanErrorType {
    system = "system",
    validation = "validation",
    cancelled = "cancelled",
}
